module.exports = __webpack_public_path__ + "img/Rings.58bd639c.png";